"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _spauiUtils = require("@tencent/spaui-utils");

var _info = _interopRequireDefault(require("./info"));

var _drop_menu_trigger_props = require("./drop_menu_trigger_props");

var _drop_menu_alignment = _interopRequireDefault(require("./drop_menu_alignment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @class
 */
var DropMenuTrigger =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(DropMenuTrigger, _PureComponent);

  function DropMenuTrigger(props) {
    var _this;

    _classCallCheck(this, DropMenuTrigger);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DropMenuTrigger).call(this, props));

    _this.nullList();

    _this.state = {
      open: props.open || false
    };
    _this.handleOpen = _this.handleOpen.bind(_assertThisInitialized(_this));
    _this.handleMouseOver = _this.handleMouseOver.bind(_assertThisInitialized(_this));
    _this.handleMouseOut = _this.handleMouseOut.bind(_assertThisInitialized(_this));
    _this.handleDocumentClick = _this.handleDocumentClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(DropMenuTrigger, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateDocumentClick();
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (typeof nextProps.open !== 'undefined') {
        this.setState({
          open: nextProps.open || false
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateDocumentClick();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeDocumentClick();
      this.nullList();
    }
  }, {
    key: "nullList",
    value: function nullList() {
      this.hoverTimeout = null;
    } // 监听页面点击

  }, {
    key: "updateDocumentClick",
    value: function updateDocumentClick() {
      var open = this.state.open;
      var _this$props = this.props,
          trigger = _this$props.trigger,
          documentClickAutoHide = _this$props.documentClickAutoHide;

      if (trigger === 'click' && documentClickAutoHide) {
        // 需要回收
        if (open && !this.haveDocumentClick) {
          if ((typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && (0, _spauiUtils.isFunction)(document.addEventListener)) {
            document.addEventListener('click', this.handleDocumentClick);
          }

          this.haveDocumentClick = true;
        } else if (!open) {
          this.removeDocumentClick();
        }
      }
    } // 去除页面点击

  }, {
    key: "removeDocumentClick",
    value: function removeDocumentClick() {
      var _this$props2 = this.props,
          trigger = _this$props2.trigger,
          documentClickAutoHide = _this$props2.documentClickAutoHide;

      if (trigger === 'click' && documentClickAutoHide) {
        if (this.haveDocumentClick) {
          if ((typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && (0, _spauiUtils.isFunction)(document.removeEventListener)) {
            document.removeEventListener('click', this.handleDocumentClick);
          }

          this.haveDocumentClick = false;
          this._insideClick = false;
        }
      }
    } // 处理页面点击

  }, {
    key: "handleDocumentClick",
    value: function handleDocumentClick(event) {
      var _this$props3 = this.props,
          propsOpen = _this$props3.open,
          onOpen = _this$props3.onOpen;
      var open = this.state.open; // 如果不是内部点击，就关闭掉

      if (open && !this._insideClick) {
        if (typeof propsOpen === 'undefined') {
          this.setState({
            open: false
          });
        }

        if ((0, _spauiUtils.isFunction)(onOpen)) {
          onOpen(event, false);
        }
      }

      this._insideClick = false;
    }
  }, {
    key: "handleOpen",
    value: function handleOpen(event, currentOpen) {
      var _this$props4 = this.props,
          propsOpen = _this$props4.open,
          onOpen = _this$props4.onOpen;
      var open = this.state.open;
      var result = !open; // 如果有指定的话，就用指定的

      if (typeof currentOpen !== 'undefined') {
        result = currentOpen;
      }

      if (typeof propsOpen === 'undefined') {
        this.setState({
          open: result
        });
      }

      if ((0, _spauiUtils.isFunction)(onOpen)) {
        onOpen(event, result);
      }
    }
  }, {
    key: "handleMouseOver",
    value: function handleMouseOver(event) {
      var _this2 = this;

      var showDelayTime = this.props.showDelayTime;
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = setTimeout(function () {
        _this2.handleOpen(event, true);
      }, showDelayTime);
    }
  }, {
    key: "handleMouseOut",
    value: function handleMouseOut(event) {
      var _this3 = this;

      var hideDelayTime = this.props.hideDelayTime;
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = setTimeout(function () {
        _this3.handleOpen(event, false);
      }, hideDelayTime);
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props5 = this.props,
          children = _this$props5.children,
          dropMenu = _this$props5.dropMenu,
          trigger = _this$props5.trigger,
          _this$props5$dropMenu = _this$props5.dropMenuWrapClassName,
          dropMenuWrapClassName = _this$props5$dropMenu === void 0 ? '' : _this$props5$dropMenu,
          closeAfterSelect = _this$props5.closeAfterSelect,
          _this$props5$alignmen = _this$props5.alignment,
          alignment = _this$props5$alignmen === void 0 ? '' : _this$props5$alignmen,
          _this$props5$dropMenu2 = _this$props5.dropMenuWidth,
          dropMenuWidth = _this$props5$dropMenu2 === void 0 ? 0 : _this$props5$dropMenu2;
      var open = this.state.open;
      var childrenDom = null;
      var hoverEvent = {};
      var clickEvent = {};
      var dropMenuDivProps = {};
      var dropMenuProps = {};
      var dropMenuDom = null;
      var dropMenuDefaultStyle = {};
      var dropMenuStyle;

      if (!children) {
        return null;
      }

      if (trigger === 'hover') {
        hoverEvent = {
          onMouseOver: this.handleMouseOver,
          onMouseOut: this.handleMouseOut
        };
        childrenDom = (0, _react.cloneElement)(children, hoverEvent);
      } else {
        childrenDom = (0, _react.cloneElement)(children, {
          onClick: function onClick(event) {
            if (_this4.haveDocumentClick) {
              _this4._insideClick = true;
            }

            _this4.handleOpen(event);
          }
        });
        clickEvent = {
          onClick: function onClick() {
            _this4._insideClick = true;
          }
        };
      }

      if ((alignment === 'right' || alignment === 'auto') && open) {
        if (dropMenu && dropMenu.props && dropMenu.props.style) {
          dropMenuDefaultStyle = dropMenu.props.style;
        }

        dropMenuStyle = _objectSpread({}, dropMenuDefaultStyle, {
          position: 'relative',
          left: '0'
        });

        if (dropMenuWidth > 0) {
          dropMenuStyle.width = dropMenuWidth;
        }
      } else {
        if (dropMenu && dropMenu.props && dropMenu.props.style && open) {
          dropMenuStyle = dropMenu.props.style;
        }
      } // 可用于原生div的标签，进行区分主要是为了避免dropMenu是原生标签时会warning


      dropMenuDivProps = _objectSpread({}, hoverEvent, {}, clickEvent, {
        style: dropMenuStyle
      });
      dropMenuProps = _objectSpread({}, dropMenuDivProps, {
        closeAfterSelect: closeAfterSelect,
        handleOpen: this.handleOpen
      });

      if (dropMenu) {
        // 字符串的是原始标签，这种是不支持show参数的
        if (typeof dropMenu.type !== 'string') {
          dropMenuProps.show = open;
          dropMenuProps.open = open;
          dropMenuDom = (0, _react.cloneElement)(dropMenu, dropMenuProps);
        } else {
          if (open) {
            dropMenuDom = (0, _react.cloneElement)(dropMenu, dropMenuDivProps);
          }
        }
      }

      if ((alignment === 'right' || alignment === 'auto') && open) {
        dropMenuDom = _react["default"].createElement(_drop_menu_alignment["default"], {
          alignment: alignment,
          show: open,
          dropMenuWidth: dropMenuWidth
        }, dropMenuDom);
      }

      return _react["default"].createElement("div", (0, _spauiUtils.globalProps)(this.props, {
        className: (0, _classnames["default"])('spaui-dropmenu-group', {
          open: open
        })
      }, DropMenuTrigger, this.props), childrenDom, dropMenu ? _react["default"].createElement("div", {
        className: dropMenuWrapClassName
      }, dropMenuDom) : null);
    }
  }]);

  return DropMenuTrigger;
}(_react.PureComponent); // 组件标记


_defineProperty(DropMenuTrigger, "propTypes", _drop_menu_trigger_props.propTypes);

_defineProperty(DropMenuTrigger, "defaultProps", _drop_menu_trigger_props.defaultProps);

(0, _spauiUtils.setComponentMark)(DropMenuTrigger, _info["default"]); // 组件上报

(0, _spauiUtils.reportComponentUsage)(_objectSpread({
  scope: 'spaui'
}, _info["default"])); // 用于 focus 样式只在键盘索引时生效，而在鼠标操作时不生效

(0, _spauiUtils.initFocusManager)('spaui-focus-disabled');
var _default = DropMenuTrigger;
exports["default"] = _default;